<template>
    <div class="modal" style="display: flex">
        <div class="modal-background" @click="$root.$children[0].toggleAboutScreen()"></div>
        <div class="modal-card">
            <section class="modal-card-body">
                <h2 class="is-size-4">Sobre</h2><br/>
                Você fez uma postagem na internet e recebeu um comentário que te fez subir o sangue. Como você lida com
                essa pessoa sem noção?<br/><br/>
                <b>"Eu odeio comunicação não-violenta"</b> é um jogo sobre a dificuldade de ter empatia em tempos sombrios. O
                jogo faz parte da <b><a target="_blank" href="https://itch.io/jam/antifa-game-jam">Antifa Game Jam 2019</a></b>.
            </section>
        </div>
        <button class="modal-close is-large" aria-label="close"
                @click="$root.$children[0].toggleAboutScreen()"></button>
    </div>
</template>

<script>
    export default {
        name: 'AboutScreen'
    }
</script>

<style scoped>
</style>